import { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, InlineAlert, Spinner } from "@/components/common";
import api from "@/lib/api";
import { formatApiError } from "@/lib/formatError";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setResult(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Reset your password" subtitle="We'll send a reset link to your email." footer={<Link to="/login" className="link">Back to sign in</Link>}>
      {result ? (
        <InlineAlert tone="success" title="Check your inbox">
          {result.message}
          {result.delivery === "log" && <p className="mt-1">Email isn't configured on this server yet — the reset link was written to the server log.</p>}
        </InlineAlert>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email"><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></Field>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">{loading && <Spinner className="text-white" />} Send reset link</Button>
        </form>
      )}
    </AuthLayout>
  );
}
